export enum Feature {
  payment = 'payment'
}
export type FeatureList = Record<Feature, boolean>;
export const DEFAULT_FEATURE_LIST: FeatureList = {
  [Feature.payment]: false
};
